import cloneDeep from "lodash/cloneDeep";
import * as uuid from "uuid";
import $ from "jquery";

import {setNewActiveQuote, updateCurrentQuote} from "../misc/quotesFunctions";
import {clearCart, restoreCart} from "./actionFunctions";
import {updateAllWizardValues} from "./wizardFunctions";
import {setActiveQuoteIndex, setQuotes} from "./roomsFunctions";
import {setCustomAddedDiscounts, setDiscountSections} from "./priceWorksheetActions";
import ActionTypes from "../misc/actionTypes";


export const deleteQuote = (event) => {
  return async (dispatch, getState) => {

    event.preventDefault();
    event.stopPropagation(); // remove quoteClick

    const {cartState, wizardState, quotesState, priceWorksheetState} = getState();

    const {cartItems} = cartState;
    const {allWizardsValues, wizardIsActive} = wizardState;
    const {quotes, activeQuoteIndex} = quotesState;
    const {discountSections, customAddedDiscounts} = priceWorksheetState;

    //1) update cartItems
    let newCartItems = cartItems
      .filter(cartItem => cartItem.currentQuote !== activeQuoteIndex)
      .map(cartItem => {
        if (cartItem.currentQuote > activeQuoteIndex) {
          cartItem.cartFeature.notesList[cartItem.currentQuote - 1] = cartItem.cartFeature.notesList[cartItem.currentQuote]; // change cart notes
          cartItem.currentQuote = cartItem.currentQuote - 1;  // change cart item quote
        }
        return cartItem
      });
    let changedCartFeatures = [];
    newCartItems.forEach(cartItem => {
      if (!changedCartFeatures.includes(cartItem.cartFeature.dbFeature.id)) { // remove last known not if it exist
        delete cartItem.cartFeature.notesList[quotes.length];
        changedCartFeatures.push(cartItem.cartFeature.dbFeature.id);
      }
    })
    dispatch(clearCart());
    dispatch(restoreCart({cartItems: newCartItems}));

    //2) update wizard
    if (wizardIsActive && allWizardsValues.length) {
      let newAllValues = allWizardsValues
        .filter(selectedObject => selectedObject.quoteIndex !== activeQuoteIndex)
        .map(selectedObject => {
          if (selectedObject.quoteIndex > activeQuoteIndex) {
            selectedObject.quoteIndex = selectedObject.quoteIndex - 1;  // change cart item quote
          }
          return selectedObject
        });
      dispatch(updateAllWizardValues(newAllValues));
    }

    //3) update priceworksheet
    let clonedCustomDiscounts = customAddedDiscounts
      .filter(customDisc => customDisc.quoteIndex !== activeQuoteIndex)
      .map(selectedObject => {
        if (selectedObject.quoteIndex > activeQuoteIndex) {
          selectedObject.quoteIndex = selectedObject.quoteIndex - 1;  // change cart item quote
        }
        return selectedObject
      });
    dispatch(setCustomAddedDiscounts([...clonedCustomDiscounts]));
    dispatch(setDiscountSections(discountSections.map(discountSection => {
      discountSection.discounts = discountSection.discounts.map(discount => {
        if (discount.roomValues) {
          if (discount.roomValues[activeQuoteIndex]) {
            delete discount.roomValues[activeQuoteIndex];
          }
          Object.keys(discount.roomValues).forEach(roomIndex => {
            if (roomIndex > activeQuoteIndex) {
              discount.roomValues[roomIndex - 1] = discount.roomValues[roomIndex];
            }
          })
        }
        return discount;
      })
      return discountSection
    })));

    //4) update quotes
    quotes.splice(activeQuoteIndex, 1);
    if (activeQuoteIndex) { // if we delete 0 (first) quote - let it stay the first active
      dispatch(setActiveQuoteIndex(activeQuoteIndex - 1));
    }
    await setNewActiveQuote(activeQuoteIndex ? activeQuoteIndex - 1 : 0, quotes);
    dispatch(setQuotes([...quotes]));
    $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS);
  }
}

export const cloneQuote = (event) => {
  return async (dispatch, getState) => {

    event.preventDefault();
    event.stopPropagation(); // remove quoteClick // why? let it be

    const {cartState, wizardState, quotesState, priceWorksheetState} = getState();

    const {cartItems} = cartState;
    const {allWizardsValues, wizardIsActive} = wizardState;
    const {quotes, activeQuoteIndex} = quotesState;
    const {discountSections, customAddedDiscounts} = priceWorksheetState;

    //1) clone cartItems
    const newQuoteIndex = quotes.length;
    let createdCartItems = {}; // {"oldUuid": "newUuid"}
    let clonedCartItems = cartItems
      .filter(cartItem => cartItem.currentQuote === activeQuoteIndex && !cartItem.isMinimumCharge)
      .map(cartItem => {
        const newUUID = uuid.v4();
        createdCartItems[cartItem.id] = newUUID;
        const newCI = Object.assign({}, cartItem, {
          id: newUUID,
          currentQuote: newQuoteIndex,
        });
        newCI.cartFeature.notesList[newQuoteIndex] = cartItem.cartFeature.notesList[cartItem.currentQuote]; // copy cart notes
        return newCI
      })
      .map(cartItem => {
        if (cartItem.bundleParentId && createdCartItems[cartItem.bundleParentId]) {
          // console.log("cartItem.bundleParentId was updated", cartItem.bundleParentId, createdCartItems, createdCartItems[cartItem.bundleParentId]);
          cartItem.bundleParentId = createdCartItems[cartItem.bundleParentId]; // assign new parent
        }
        return cartItem
      });
    dispatch(clearCart());
    dispatch(restoreCart({cartItems: [...cartItems, ...clonedCartItems]}));

    //2) clone wizards
    if (wizardIsActive && allWizardsValues.length) {
      let newAllValues = allWizardsValues
        .filter(selectedObject => selectedObject.quoteIndex === activeQuoteIndex)
        .map(selectedObject => {
          return Object.assign({}, selectedObject, {
            quoteIndex: newQuoteIndex,
          })
        });
      dispatch(updateAllWizardValues([...allWizardsValues, ...newAllValues]));
    }

    //3) clone priceworksheet
    let clonedCustomDiscounts = customAddedDiscounts
      .filter(customDisc => customDisc.quoteIndex === activeQuoteIndex)
      .map(customDisc => {
        const uuIdId = uuid();
        return Object.assign({}, customDisc, {
          quoteIndex: newQuoteIndex,
          id: uuIdId,
          uuId: uuIdId,
        })
      });
    dispatch(setCustomAddedDiscounts([...customAddedDiscounts, ...clonedCustomDiscounts]));
    dispatch(setDiscountSections(discountSections.map(discountSection => {
      discountSection.discounts = discountSection.discounts.map(discount => {
        if (discount.roomValues && discount.roomValues[activeQuoteIndex]) {
          discount.roomValues[newQuoteIndex] = cloneDeep(discount.roomValues[activeQuoteIndex]);
        }
        return discount;
      })
      return discountSection
    })));

    //4) clone quote
    const currentQuotes = await updateCurrentQuote();
    const newQuote = cloneDeep(currentQuotes[activeQuoteIndex]);
    // console.log("currentQuote", currentQuotes, newQuote);
    const newQuotes = [...currentQuotes, newQuote];
    dispatch(setQuotes(newQuotes));
    dispatch(setActiveQuoteIndex(newQuotes.length - 1));
  }
}
